import { useMemo } from 'react';

export const PREVIOUS_PAGE_URL_STORAGE_KEY = 'previousPageUrl';

const getPreviousPageUrl = () => window.sessionStorage.getItem(PREVIOUS_PAGE_URL_STORAGE_KEY) ?? '';

const setPreviousPageUrl = (url: string) => window.sessionStorage.setItem(PREVIOUS_PAGE_URL_STORAGE_KEY, url);

const setPreviousPageUrlWithCurrentPageUrl = () => setPreviousPageUrl(window.location.href);

/**
 * A lot of pages can redirect to the payment and error pages.
 * We need a way to save the url to be able to go back.
 * @see ../__stories__/usePreviousPageUrl.stories.mdx
 */
const usePreviousPageUrl = () => {
  const previousPageUrl = useMemo(() => getPreviousPageUrl(), []);

  return {
    actions: {
      setPreviousPageUrl,
      setPreviousPageUrlWithCurrentPageUrl,
    },
    states: {
      previousPageUrl,
    },
    selectors: {
      getPreviousPageUrl,
    },
  };
};

export default usePreviousPageUrl;
